import { safeExecute } from '@/utils/function.util';
import { isDebugModeOn } from '@/utils/misc.util';

/**
 * Filters out non-ASCII characters from a string to ensure btoa compatibility.
 * Only allows alphanumeric characters, spaces, and common punctuation.
 */
function sanitizeForBtoa(str: string): string {
  // Allow ASCII printable characters (32-126) and common search characters
  // This includes letters, numbers, spaces, and basic punctuation
  return str.replace(/[^\x20-\x7E]/g, '');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function encode(value: any) {
  const stringValue = JSON.stringify(value);
  const sanitizedValue = sanitizeForBtoa(stringValue);

  return isDebugModeOn ? sanitizedValue : btoa(sanitizedValue);
}

export function decode<T>(value: string, defaultValue: T): T;
// eslint-disable-next-line no-redeclare
export function decode<T>(value: string, defaultValue?: T): T | undefined;

// eslint-disable-next-line no-redeclare
export function decode<T>(value: string, defaultValue?: T) {
  return safeExecute<T>(() => {
    return JSON.parse(isDebugModeOn ? value : atob(value)) as T;
  }, defaultValue);
}
